/**
 * @deprecated - You can't replace this. To change this we need to work with the mobile team to change it in the apps and make a force update
 * For future communication with the webview please use appViewMessageHandler.
 *
 * This function is here as part of the effort to keep all the webview communication in the same place.
 */

export function legacyAppViewMessageHandler(handler: string, message: string) {
  if (window.webkit?.messageHandlers) {
    window.webkit.messageHandlers[handler].postMessage({
      message,
    })
  } else if (window.appInterface) {
    window.appInterface.postMessage(message)
  }
}

export function appViewMessageHandler(handler: string, dataToSend: any) {
  if (typeof window.webkit?.messageHandlers?.[handler]?.postMessage === 'function') {
    const message = JSON.stringify(dataToSend)
    window.webkit.messageHandlers[handler].postMessage({
      message,
    })
  } else if (typeof window.appInterface?.postMessage === 'function') {
    const message = JSON.stringify({
      event: handler,
      dataToSend,
    })
    window.appInterface.postMessage(message)
  }
}
